(() => {
  const selectors = {
    modalWrapper: '.qrModal__wrapper',
    closeModalButton: '.qrModal__close',
    stayStoreButton: '.qrModal__windowButtonClose',
    overlay: '.qrModal__overlay',
    modalTitle: '.qrModal__windowTitle',
    modalSubtitle: '.qrModal__windowSubtitle',
    modalButton: '.qrModal__windowButtonRedirect',

    modalWrapperActiveClass: 'qrModal__wrapper--active',
    overlayActiveClass: 'qrModal__overlay--active'
  }

  const closeModalButton = document.querySelector(selectors.closeModalButton);
  const stayStoreButton = document.querySelector(selectors.stayStoreButton);

  async function fetchIsoCode() {
    try {
      const response = await fetch('/browsing_context_suggestions.json');
      const data = await response.json();
      const modalWrapper = document.querySelector(selectors.modalWrapper);
      const currentIsoCode = modalWrapper.dataset.currentStore;


      if (currentIsoCode.toUpperCase() !== data.detected_values.country.handle) {
        const isoCode = data.detected_values.country.handle;
        const modalIsoCode = isoCode == 'DE' || isoCode == 'IT'? isoCode : 'EN';

        createModal(modalIsoCode);
        showModal();
      }
    } catch (error) {
      console.error(error);
    }
  }

  if (!getCookie('languageModal')) {
    fetchIsoCode();
  }

  function createModal(modalIsoCode) {
    const modalTitle = document.querySelector(selectors.modalTitle);
    const modalSubtitle = document.querySelector(selectors.modalSubtitle);
    const modalButton = document.querySelector(selectors.modalButton);
    const modalIsoCodeLowercase = modalIsoCode.charAt(0).toUpperCase() + modalIsoCode.slice(1).toLowerCase();
    const title = `title${modalIsoCodeLowercase}`;
    const subtitle  = `subtitle${modalIsoCodeLowercase}`;
    const url = `url${modalIsoCodeLowercase}`;
    const buttonTitle = `buttonTitle${modalIsoCodeLowercase}`;

    modalTitle.innerHTML = modalTitle.dataset[title];
    modalSubtitle.innerHTML = modalSubtitle.dataset[subtitle];
    modalButton.innerHTML = modalButton.dataset[buttonTitle];
    modalButton.setAttribute('href', modalButton.dataset[url]);
  }

  function showModal() {
    const modalWrapper = document.querySelector(selectors.modalWrapper);
    const overlay = document.querySelector(selectors.overlay);

    modalWrapper.classList.add(selectors.modalWrapperActiveClass);
    overlay.classList.add(selectors.overlayActiveClass);
  }

  function closeModal() {
    const modalWrapper = document.querySelector(selectors.modalWrapper);
    const overlay = document.querySelector(selectors.overlay);

    modalWrapper.classList.remove(selectors.modalWrapperActiveClass);
    overlay.classList.remove(selectors.overlayActiveClass);
  }

  function setCookie() {
    let now = new Date();
    let time = now.getTime();
    let expireTime = time + 60 * 60 * 1000;
    now.setTime(expireTime);
    document.cookie = "languageModal=true;expires=" + now.toUTCString() + ";path=/";
  }

  function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  closeModalButton.addEventListener('click', closeModal);
  stayStoreButton.addEventListener('click', () => {
    setCookie();
    closeModal();
  });
})();
